import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  templateName: Yup.string()
    .matches(
      /^[a-z0-9_]+$/,
      "Template Name can only contain lowercase , numbers and underscores"
    )
    .required("Enter template name."),
  templateLanguage: Yup.object({
    code_id: Yup.string().required("Select template language."),
  }),

  category: Yup.string().required("Category is required"),
  status: Yup.string().required("Select the status"),

  templateHeader: Yup.object().shape({
    type: Yup.mixed().nullable(),
    count_of_variable: Yup.number(),

    text: Yup.mixed().when("type", {
      is: (type) => type === "text",
      then: () => Yup.string().required("Text is required"),
    }),

    example: Yup.array().when("type", (type, schema) => {
      const headerType = Array.isArray(type) ? type[0] : type;

      if (["image", "video", "document"].includes(headerType)) {
        return Yup.array()
          .required("Upload file is required")
          .min(1, "Upload file is required")
          .of(
            Yup.object().shape({
              url: Yup.string().required("Upload file is required"),
              timestamp: Yup.mixed().required(),
            })
          );
      }

      if (headerType === "text") {
        return Yup.array().of(
          Yup.string().required("Sample value is required")
        );
      }

      return schema;
    }),
  }),

  templateBody: Yup.object().shape({
    text: Yup.string().required("Body is required"),
    count_of_variable: Yup.number(),
    example: Yup.array(
      Yup.object().shape({
        example: Yup.string().when("count_of_variable", {
          is: (number) => number > 0,
          then: () => Yup.string().required("Fill sample values."),
        }),
      })
    ),
  }),

  templateButtons: Yup.object().shape({
    type: Yup.mixed().nullable(),
    count_of_variable: Yup.number(),
    buttons: Yup.array().when("type", {
      is: (val) => val !== null,
      then: () =>
        Yup.array(
          Yup.object().shape({
            button_type: Yup.string().when("type", {
              is: (type) => type === "call_to_action",
              then: () => Yup.string().required("Select the action type"),
            }),
            text: Yup.string().required("Button text is required"),
            url_type: Yup.string().when("button_type", {
              is: (type) => type === "url",
              then: () => Yup.string().required("Select the url type"),
            }),
            payload: Yup.string().when("url_type", {
              is: (type) => type === "static",
              then: () =>
                Yup.string()
                  .matches(
                    /^(?:(https?):\/\/)?(?:www\.)?(?!.*(http|https|www\.))[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\/[a-zA-Z0-9._~:/?#\[\]@!$&'()*+,;=%-]*)?$/,
                    "Enter correct url."
                  )
                  .required("This is the required field."),
            }),
          })
        ),
    }),
    example: Yup.array(
      Yup.object().shape({
        example: Yup.string().when("count_of_variable", {
          is: (number) => number > 0,
          then: () => Yup.string().required("Fill sample values."),
        }),
      })
    ),
  }),
});

export default validationSchema;
